import { ContentKey } from "../../../../features/talentProfile/TalentDetails";
import DeleteButton from "./DeleteButton";
import EditButton from "./EditButton";
import { DataItem } from "./FormTable";
import ToggleButton from "./ToggleButton";
import { ButtonTableCell } from "./styles";

type Props = {
  obj: DataItem;
  disableEditRow?: boolean;
  disableEditOnly?: boolean;
  contentKey?: string;
  handleOpenEditModal: (content: ContentKey, id?: string) => void;
  handleDelete?: (id: string) => void;
  handleToggle?: (id: string) => void;
};

const FormTableButtons = ({
  obj,
  disableEditRow,
  disableEditOnly,
  handleOpenEditModal,
  contentKey,
  handleDelete,
  handleToggle,
}: Props) => (
  <>
    <ButtonTableCell disabled={obj.disabled} align="right">
      {!disableEditRow && !disableEditOnly && !obj.disabled && (
        <EditButton
          id={obj.id}
          handleOpenEditModal={handleOpenEditModal}
          contentKey={contentKey}
        />
      )}
    </ButtonTableCell>
    {!disableEditRow && !!handleDelete && obj.deletable && (
      <ButtonTableCell disabled={obj.disabled} align="right">
        <DeleteButton handleDelete={handleDelete} id={obj.id} />
      </ButtonTableCell>
    )}
    {!!handleToggle && obj.toggleable && (
      <ButtonTableCell disabled={obj.disabled} align="right">
        <ToggleButton
          handleToggle={handleToggle}
          id={obj.id}
          disabled={obj.disabled}
        />
      </ButtonTableCell>
    )}
  </>
);

export default FormTableButtons;
